import { render, staticRenderFns } from "./spike-address.vue?vue&type=template&id=014a801d&scoped=true&"
import script from "./spike-address.vue?vue&type=script&lang=js&"
export * from "./spike-address.vue?vue&type=script&lang=js&"
import style0 from "./spike-address.vue?vue&type=style&index=0&id=014a801d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014a801d",
  null
  
)

export default component.exports